import * as Sentry from '@sentry/browser'
import { SENTRY_DSN } from 'constants/sdkConstants'

if (SENTRY_DSN) {
  Sentry.init({ dsn: SENTRY_DSN })
}

export const sentrySdk = Sentry
